<template>
  <v-card style="height: 100%;">
    <v-card
      style="width: 100%;min-height:100%;align-items: center;display: inline-block;"
    >
      <v-card-text style="font-size: 18px">
        {{ $t("initialSettings") }}
      </v-card-text>
      <v-divider></v-divider>

      <v-row
        justify="space-around"
        align="center"
        v-if="Settings"
        style="margin-right: 0px; margin-left: 0px"
      >
        <v-col
          cols="12"
          xs="12"
          sm="12"
          lg="12"
          md="12"
          style="padding-bottom: 0 !important;"
        >
          <filterVehicles></filterVehicles>
        </v-col>
      </v-row>

      <v-row
        justify="space-around"
        align="center"
        v-else
        style="margin-right: 0px; margin-left: 0px"
      >
        <v-col cols="12" xs="12" sm="12" lg="8" md="12" align-self="center">
          <v-container>
            <v-col cols="12" style="padding: 5px; min-height: 80px;">
              <span>
                <v-icon :color="colorTheme">mdi-filter-variant</v-icon>
              </span>
              {{ $t("SystemofUnits") }}
            </v-col>
            <v-col cols="auto" style="text-align: -webkit-center;">
              <v-col lg="8">
                <v-select
                  :label="$t('distance')"
                  outlined
                  v-model="SelectedDistance"
                  style="width: 80%;"
                  :color="colorTheme"
                  :items="Distance"
                ></v-select>
              </v-col>
            </v-col>
            <v-col cols="auto" style="text-align: -webkit-center;">
              <v-col lg="8">
                <v-select
                  :label="$t('volume')"
                  outlined
                  v-model="SelectedVolume"
                  style="width: 80%;"
                  :color="colorTheme"
                  :items="Volumen"
                ></v-select>
              </v-col>
            </v-col>
            <v-col cols="auto" style="text-align: -webkit-center;">
              <v-col lg="8">
                <v-select
                  :label="$t('temperature')"
                  outlined
                  v-model="SelectedTemperature"
                  style="width: 80%;"
                  :color="colorTheme"
                  :items="Temperature"
                ></v-select>
              </v-col>
            </v-col>
          </v-container>
        </v-col>
      </v-row>

      <v-row
        justify="end"
        align="center"
        style="padding: 5px; margin-right: 0px; margin-left: 0px;padding-top: 0;"
      >
        <v-col
          cols="12"
          sm="1"
          md="1"
          lg="1"
          style="max-width: 50%;"
          v-if="!Settings"
        >
          <v-btn
            dark
            :color="colorTheme"
            v-on:click="setSettings()"
            width="110"
            >{{ $t("back") }}</v-btn
          >
        </v-col>
        <v-col cols="12" sm="1" md="1" lg="1" style="max-width: 50%;" v-else>
          <v-btn dark :color="colorTheme" v-on:click="cancel()" width="110">{{
            $t("cancel")
          }}</v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="1"
          md="1"
          lg="1"
          style="max-width: 50%;"
          v-if="Settings"
        >
          <v-btn
            :dark="!nextWizzard"
            :color="colorTheme"
            width="110"
            v-on:click="setSettings()"
            :disabled="nextWizzard"
            >{{ $t("continue") }}</v-btn
          >
        </v-col>
        <v-col cols="12" sm="1" md="1" lg="1" style="max-width: 50%;" v-else>
          <v-btn dark :color="colorTheme" v-on:click="accept()" width="110">
            {{ $t("accept") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  name: "initialSettings",
  components: {
    filterVehicles: () => import("@/components/filterVehicles")
  },
  data() {
    return {
      Settings: true
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  computed: {
    ...mapState([
      "colorTheme",
      "distance",
      "volume",
      "temperature",
      "Distance",
      "Volumen",
      "Temperature",
      "nextWizzard"
    ]),
    SelectedDistance: {
      get: function() {
        return this.$store.state.SelectedDistance;
      },
      set: function(val) {
        this.$store.commit("SelectedDistance", val);
      }
    },
    SelectedVolume: {
      get: function() {
        return this.$store.state.SelectedVolume;
      },
      set: function(val) {
        this.$store.commit("SelectedVolume", val);
      }
    },
    SelectedTemperature: {
      get: function() {
        return this.$store.state.SelectedTemperature;
      },
      set: function(val) {
        this.$store.commit("SelectedTemperature", val);
      }
    }
  },
  methods: {
    cancel() {
      this.$store.commit("readListOfReports", []);
      this.$store.commit("cancelMultipleAccess");
      this.$store.dispatch("logOutApp", null);
    },
    setSettings() {
      this.Settings = !this.Settings;
    },
    accept() {
      this.$store.dispatch("setPersonalization", ["initialSettings"]);
    }
  }
};
</script>
